import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, Divider, DynamicSvg, isFirstItem, Typography } from '@airtel/air-design-system';
import { FlatList, ScrollView, View } from 'react-native';
import { withBoundaries } from '../../../../hoc';
import { FilterItem } from '../filter-item';
import { getFilterDesktopStyles } from './FilterDesktopStyles';
var FilterHeader = _ref => {
  var style = _ref.style,
    onClear = _ref.onClear;
  return _jsxs(View, Object.assign({
    style: style
  }, {
    children: [_jsx(Typography, {
      text: "Filter",
      type: "title-single-line-lg"
    }), _jsx(Button, {
      buttonType: "tertiary",
      title: "Clear all",
      size: "md",
      onPress: onClear
    })]
  }));
};
var FilterDesktopComponent = props => {
  var _props$isInsideModal = props.isInsideModal,
    isInsideModal = _props$isInsideModal === void 0 ? false : _props$isInsideModal,
    filterData = props.filterData,
    type = props.type,
    onClear = props.onClear,
    onCheck = props.onCheck;
  var filterDesktopStyles = getFilterDesktopStyles();
  var renderFilterItemValue = function renderFilterItemValue(_temp, isLastItem) {
    var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$item = _ref2.item,
      item = _ref2$item === void 0 ? {} : _ref2$item,
      _ref2$index = _ref2.index,
      index = _ref2$index === void 0 ? 0 : _ref2$index;
    var style = isLastItem ? [filterDesktopStyles.itemContainer, filterDesktopStyles.paddingBottomStyle] : [filterDesktopStyles.itemContainer];
    return _jsx(FilterItem, {
      item: item,
      index: index,
      type: type,
      onFilterItemPress: onCheck,
      style: style
    });
  };
  var getDivideStyle = index => {
    var marginTopStyle = isFirstItem(index) ? '' : filterDesktopStyles.marginTopStyle;
    return [Object.assign({}, marginTopStyle), filterDesktopStyles.dividerStyle];
  };
  var Component = isInsideModal ? ScrollView : Card;
  var componentProps = isInsideModal ? {
    showVerticalScrollIndicator: false,
    showHorizontalScrollIndicator: false
  } : {
    showShadow: false,
    noPadding: true,
    noHorizontalPadding: true,
    style: filterDesktopStyles.cardStyle
  };
  return _jsxs(Component, Object.assign({}, componentProps, {
    children: [_jsx(FilterHeader, {
      style: filterDesktopStyles.header,
      onClear: onClear
    }), filterData === null || filterData === void 0 ? void 0 : filterData.map((filterItem, index) => {
      var _filterItem$filterCat = filterItem.filterCategory,
        filterCategory = _filterItem$filterCat === void 0 ? '' : _filterItem$filterCat,
        filterCategoryIcon = filterItem.filterCategoryIcon,
        filterCategoryIconProps = filterItem.filterCategoryIconProps,
        filterItemValue = filterItem.filterItemValue;
      return _jsxs(View, Object.assign({
        style: filterDesktopStyles.contentStyle
      }, {
        children: [_jsx(Divider, {
          height: 1,
          style: getDivideStyle(index)
        }), _jsxs(View, Object.assign({
          style: filterDesktopStyles.titleContainer
        }, {
          children: [!!filterCategoryIcon && _jsx(DynamicSvg, Object.assign({
            iconName: filterCategoryIcon,
            width: 20,
            height: 20
          }, filterCategoryIconProps)), _jsx(Typography, {
            text: filterCategory,
            type: "title-single-line-lg"
          })]
        })), _jsx(FlatList, {
          data: filterItemValue,
          renderItem: _ref3 => {
            var item = _ref3.item,
              index = _ref3.index;
            var isLastItem = index === (filterItemValue === null || filterItemValue === void 0 ? void 0 : filterItemValue.length) - 1;
            return renderFilterItemValue({
              item,
              index
            }, isLastItem);
          },
          keyExtractor: (_, index) => "section-list-" + index
        })]
      }), "" + filterCategory + index);
    })]
  }));
};
export var FilterDesktop = withBoundaries(FilterDesktopComponent);